import { initApexCharts } from '@/lib/apexcharts'
import { initI18n } from '@/lib/i18n'
import { initToasts } from '@/lib/toastify'
import { initVueAxios } from '@/lib/vue-axios'
import { initVueQuery } from '@/lib/vue-query'
import { initVuetify } from '@/lib/vuetify'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

const app = createApp(App)
app.use(createPinia())
app.use(router)

initVuetify(app)
initI18n(app)
initVueQuery(app)
initVueAxios(app)
initToasts(app)
initApexCharts(app)

app.mount('#app')
